export const GREEN = "#0aaa99";
export const PINK = "#f29c86";
export const YELLOW = "#E4E71A";
export const BLACK = "#231f20";
